module.exports = __webpack_public_path__ + "img/void.b0aa6736.png";